import axios from 'axios';

import { onIntercomReady } from '@/composables/useIntercom';
import useMinimalApp from '@/composables/useMinimalApp';
import appConfig from '@/config';
import { ADMIN_PANEL } from '@/constants/team';

async function fetchIntercomUserJwt() {
  try {
    const { data } = await axios.get('/v0.1/intercom/user-jwt');
    return data.token ?? null;
  } catch {
    return null;
  }
}

export const enableIntercom = (currentUser, currentOrg, userJwt) => {
  const settings = {
    app_id: appConfig.intercom.workspaceId,
    hide_default_launcher: true,
    email: currentUser.email,
    company: {
      company_id: currentOrg.id,
      name: currentOrg.name,
    },
  };
  if (currentUser.first_name) {
    settings.name = `${currentUser.first_name} ${currentUser.last_name}`;
  }
  if (userJwt) {
    settings.intercom_user_jwt = userJwt;
  }
  window.intercomSettings = settings;

  if (currentUser.email) {
    (function () {
      const w = window;
      const ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
        onIntercomReady();
      } else {
        const d = document;
        const i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        const l = function () {
          const s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = `https://widget.intercom.io/widget/${appConfig.intercom.workspaceId}`;
          s.onload = function () {
            onIntercomReady();
          };
          const x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        l();
      }
    })();
  }
};

export function disableIntercom() {
  if (typeof window.Intercom === 'function') {
    window.Intercom('shutdown');
  }
}

export const maybeEnableIntercom = async (
  currentUser,
  currentOrg,
  currentAuth,
) => {
  const { isMinimalView } = useMinimalApp();
  if (!appConfig.intercom.enabled || isMinimalView) {
    return;
  }
  if (currentAuth && currentAuth.authorizer_type === ADMIN_PANEL) {
    return;
  }
  const userJwt = await fetchIntercomUserJwt();
  if (!userJwt) return;
  enableIntercom(currentUser, currentOrg, userJwt);
};
